// extracted by mini-css-extract-plugin
export var button = "player-module--button--4323c";
export var centerControls = "player-module--centerControls--ca11e";
export var container = "player-module--container--33f95";
export var footer = "player-module--footer--ebfd0";
export var footerContent = "player-module--footerContent--81e64";
export var footerContentEnter = "player-module--footerContentEnter--4a123";
export var footerContentEnterActive = "player-module--footerContentEnterActive--7cda0";
export var footerContentEnterDone = "player-module--footerContentEnterDone--35095";
export var footerContentExit = "player-module--footerContentExit--9e3c0";
export var footerContentExitActive = "player-module--footerContentExitActive--bc1eb";
export var loading = "player-module--loading--74c23";
export var playButton = "player-module--playButton--787db";
export var playerControls = "player-module--playerControls--24984";
export var progress = "player-module--progress--4772d";
export var progressContainer = "player-module--progressContainer--d73fe";
export var shimmer = "player-module--shimmer--23faa";